import classnames from 'classnames'
import type { PropsWithChildren, FC } from 'react'
import React from 'react'
import type { LinkProps } from 'react-router-dom'
import { Link } from 'react-router-dom'

import type { AppRoutesConfig } from '../../appRoutesConfig'
import { routes } from '../../appRoutesConfig'
import { formatPathParams, formatSearchParams } from '../../services'

import styles from './LinkWrapper.module.css'

const { Disabled } = styles

type Props = Omit<LinkProps, 'to'> & {
  toRoute: AppRoutesConfig
  targetBlank?: boolean
  'data-testid'?: string
  disabled?: boolean
  className?: string
  onClick?: () => void
}

/**
 * @deprecated Use `Link` in combination with appRoutesConfig constants
 */

export const LinkWrapper: FC<PropsWithChildren<Props>> = ({
  targetBlank,
  toRoute,
  children,
  disabled,
  className = '',
  onClick = () => {},
  ...other
}) => {
  const { searchParams, pathParams, route } = toRoute
  const { rootPath } = routes[route] || {}

  const to = {
    pathname: formatPathParams({
      path: rootPath,
      pathParams: pathParams as any
    }),
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    search: formatSearchParams({ searchParams })
  }

  return (
    <Link
      onClick={onClick}
      {...other}
      to={to}
      {...(targetBlank && { target: '_blank' })}
      className={classnames({ [Disabled]: disabled }, className)}
    >
      {children}
    </Link>
  )
}
